import { isEmpty, omit } from 'lodash';

export enum RecommendationType {
  VIEWED = 'viewed',
  VIEWED_VIEWED = 'viewedViewed',
  TRENDING = 'trending',
  NEWEST = 'newest',
  PURCHASED_TOGETHER = 'purchasedTogether',
  VIEWED_BOUGHT = 'viewedBought',
  PERSONALIZED = 'personalized',
  NEW_TRENDING = 'newTrending',
}

export enum RecommendationSlotType {
  CATEGORY = 'category',
  CUSTOM = 'custom',
  HOME = 'home',
  PRODUCT = 'product',
  CART = 'cart',
}

const ProductRelatedSlotTypeMapping: Partial<
  Record<RecommendationSlotType, boolean>
> = {
  [RecommendationSlotType.PRODUCT]: true,
  [RecommendationSlotType.CART]: true,
};

export const dynamicFiltersAvailable = (r) =>
  !!ProductRelatedSlotTypeMapping[r.slotType];

export enum FilterValueSource {
  manual = 'manual',
  api = 'api',
  product = 'product',
}

const mapFilterToValueSource = (f): FilterValueSource => {
  if (f.useCurrentValue) {
    return FilterValueSource.api;
  }

  if (f.type === 'dynamic') {
    return FilterValueSource.product;
  }

  return FilterValueSource.manual;
};

export const mapBackendFilters = (filters) =>
  filters.map((f) => ({
    ...f,
    valueSource: mapFilterToValueSource(f),
  }));

export const mapFeFilters = (filters) =>
  filters
    .filter(
      (f) =>
        !!f.name &&
        (f.valueSource !== FilterValueSource.manual || !isEmpty(f.values))
    )
    .map((f) => {
      const mapped = {
        ...f,
        useCurrentValue: f.valueSource === FilterValueSource.api,
        type: f.valueSource === FilterValueSource.product ? 'dynamic' : f.type,
      };
      if (mapped.valueSource !== FilterValueSource.manual) {
        return omit(mapped, 'values', 'valueSource');
      }
      return omit(mapped, 'valueSource');
    });
